import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { getPrettyPropertyRecordCalculationStatus } from '../../enums';
import { ChartComponent } from 'ng-apexcharts';
import { ChartOptions } from '../../interfaces/chart-options';

@Component({
    standalone: false,
    selector: 'radio-bar-chart',
    templateUrl: './radio-bar-chart.component.html',
    styleUrls: ['./radio-bar-chart.component.scss']
})
export class RadioBarChartComponent implements OnInit {
    @ViewChild('chart') chart: ChartComponent;
    @Input() chartData: any;
    chartOptions: Partial<ChartOptions>;
    chartSize = 200;
    scaled = false;

    constructor() {}

    ngOnInit() {
        const ratios = [];
        const properties = [];
        this.chartData.forEach(i => {
            ratios.push(i.ratio);
            properties.push(getPrettyPropertyRecordCalculationStatus(i.status));
        });
        const summ = ratios.reduce((acc, cur: number) => {
            return acc + cur;
        }, 0);
        this.buildChart(summ, ratios, properties);
    }

    scale() {
        this.scaled = !this.scaled;
        const changesOptions = {
            chart: {
                height: 400
            },
            plotOptions: {
                radialBar: {
                    dataLabels: {
                        name: {
                            fontSize: '18px',
                            offsetY: 0
                        },
                        value: {
                            fontSize: '16px',
                            offsetY: 50
                        }
                    }
                }
            }
        };
        const scaledChart = this.scaled ? { ...this.chartOptions, ...changesOptions } : this.chartOptions;
        this.chart.updateOptions(scaledChart);
    }

    buildChart(summ, ratios, properties) {
        this.chartOptions = {
            series: ratios,
            chart: {
                height: this.chartSize,
                type: 'radialBar'
            },
            plotOptions: {
                radialBar: {
                    dataLabels: {
                        name: {
                            fontSize: '14px',
                            offsetY: -85
                        },
                        value: {
                            fontSize: '14px',
                            offsetY: -15
                        },
                        total: {
                            show: true,
                            label: 'Total',
                            formatter: function() {
                                return summ.toFixed(2);
                            }
                        }
                    }
                }
            },
            labels: properties
        };
    }
}
